/*
 * @Author: your name
 * @Date: 2021-03-30 10:30:04
 * @LastEditTime: 2021-06-10 09:29:28
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\router\modules\product.js
 */
export default [
  
  {
    path: '/total-product-pool', 
    component: resolve => require(['../../views/product/totalProductPool'], resolve),
    name:'totalProductPool',
    meta: { title: '总产品池管理' , keepAlive : true}
  } ,
  {
    path: '/supplier-list', 
    component: resolve => require(['../../views/product/supplierList'], resolve),
    meta: { title: '供应商列表' }
  } ,
  {
    path: '/product-detail', 
    component: resolve => require(['../../views/product/productDetail'], resolve),
    meta: { title: '产品详情' }
  }  ,
  {
    path: '/product-theme-list', 
    component: resolve => require(['../../views/product/productThemeList'], resolve),
    meta: { title: '产品主题列表' }
  },
  {
    path: '/product-management', 
    component: resolve => require(['../../views/product/productManagementC'], resolve),
    meta: { title: '我的产品' }
  },
  {
    path: '/hide-product-settings', 
    component: resolve => require(['../../views/product/hideProductSettings'], resolve),
    meta: { title: '隐藏产品设置' }
  },
  {
    path: '/product-zone-page', 
    component: resolve => require(['../../views/product/productZonePage'], resolve),
    meta: { title: '专区' }
  },
  {
    path: '/product-more-list', 
    component: resolve => require(['../../views/product/productMoreList'], resolve),
    meta: { title: '产品列表' }
  },

  
]



// WEBPACK FOOTER //
// ./src/TASMini/router/modules/product.js